import { render, staticRenderFns } from "./TrialPitDrawing.vue?vue&type=template&id=4066109b&scoped=true&"
import script from "./TrialPitDrawing.vue?vue&type=script&lang=ts&"
export * from "./TrialPitDrawing.vue?vue&type=script&lang=ts&"
import style0 from "./TrialPitDrawing.vue?vue&type=style&index=0&id=4066109b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066109b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
